import React, { Fragment } from "react";
import { ActionType, DataTableAction } from "../list/list/DataTable";
import {
  ListCasinoLobbyCategoryRequest,
  ListChartsRequest,
  ListUsersRequest,
  TurnoverContributions,
  TurnoverContributionsListRequest,
  User,
  UserBonusEvent,
  UserBonusEventListRequest,
  UserBonusEventStatus,
} from "../../http/protocol";
import { getContainer } from "../../ioc/IOCSetup";
import { EntityDataTable } from "../list/list/EntityDataTable";
import { PagerModel } from "../list/list/PagerModel";
import { ListUtils } from "../list/list/ListUtils";
import { withRouter } from "react-router";
import { ListView, ListViewProps, ListViewState } from "../ListView";
import { UserService } from "../../services/UserService";
import { Form, FormListener } from "../form/Form";
import { FormGroup } from "../form/FormGroup";
import { FormInput } from "../form/FormInput";
import { Validators } from "../form/Validators";
import { Submit } from "../form/Submit";
import { ColumnType } from "../list/list/ColumnType";
import { CasinoCategoryService } from "../../services/CasinoCategoryService";
import { TurnoverContributionsService } from "../../services/TurnoverContributionsService";
import { RouteComponentProps } from "react-router-dom";
import { UserBonusEventService } from "../../services/UserBonusEventService";
import { t } from "../../i18n";

interface State extends ListViewState<UserBonusEventListRequest> {
  // form? : UserBonusEventListRequest;
  validationMap?: any;
}
interface Props extends ListViewProps, RouteComponentProps {}

export class BonusEventsListView extends ListView<State, UserBonusEventListRequest> {
  columns = [
    { property: "id", name: "ID", orderBy: "id" },
    { property: "type", name: "Type" },
    { property: "timestamp", name: "Timestamp", type: ColumnType.DATE },
    { property: "currency", name: "Currency" },
    { property: "amount", name: "Amount" },
    { property: "gameName", name: "Game" },
    {
      property: "nanoTxId",
      name: "Nano Tx",
      type: ColumnType.LINK,
      getUrl: (item: UserBonusEvent) => {
        return "/transaction/" + item.nanoTxId;
      },
    },
    { property: "product", name: "Product" },
    { property: "status", name: "Status" },
    { property: "contribution", name: "Contribution" },
    { property: "parachuteBonusBalance", name: "Bonus Balance (parachute)" },
    { property: "parachuteBonusPhase", name: "Bonus Money (parachute)", type: ColumnType.BOOLEAN },
    { property: "userBalance", name: "User Balance (total)" },
    { property: "freespins", name: "Freespins", type: ColumnType.BOOLEAN },
  ];

  // A stuck PENDING event blocks the parachute bonus from ending; marking it COMPLETED lets the bonus finish naturally.
  actions: DataTableAction[] = [
    {
      id: "markCompleted",
      name: t("bonus.events.mark-completed", undefined, "Mark Completed"),
      className: "btn btn-warning",
      iconClassName: "fa fa-check",
      type: ActionType.CONFIRMATION,
      show: (item: UserBonusEvent) => item.status === UserBonusEventStatus.PENDING,
    },
  ];

  service: UserBonusEventService;
  tableRef = React.createRef<EntityDataTable>();

  constructor(props: Props) {
    super(props, "/bonus/events/" + (props.match.params as any).id);

    const userBonusId = Number((props.match.params as any).id);

    this.state = { ...this.state, listRequest: { userBonusId: userBonusId, ...this.state.listRequest }, validationMap: {} };
    this.service = getContainer().getUserBonusEventService();
  }

  onAction(item: UserBonusEvent, action: string): Promise<any> | undefined {
    if (action === "markCompleted" && item.id !== undefined) {
      return this.service.markCompleted(item.id).then(() => this.tableRef.current?.manualSearch());
    }
    return undefined;
  }

  pagerChanged(pager: PagerModel) {
    if (this.state.listRequest) {
      let listRequest = ListUtils.toListRequest<any>(this.state.listRequest, pager);
      this.updateListState(listRequest);
    }
  }
  getTitle() {
    return "User Bonus Events";
  }

  renderContent() {
    if (!this.state.listRequest) {
      return <div />;
    }
    return (
      <Fragment>
        <EntityDataTable
          ref={this.tableRef}
          service={this.service}
          onPagerChange={this.pagerChanged.bind(this)}
          columns={this.columns}
          listRequest={this.state.listRequest}
          onAction={this.onAction.bind(this)}
          actions={this.actions}
        />
      </Fragment>
    );
  }
}

export default withRouter(BonusEventsListView);
